export enum MedicalHistoryQuestionIds {
  OnMedication = 'onMedication',
  MedicationDetails = 'medicationDetails',
  HasAllergies = 'hasAllergies',
  AllergiesDetails = 'allergiesDetails',
  HasOtherConditions = 'hasOtherConditions',
  OtherConditionsDetails = 'otherConditionsDetails',
}
